<template>
  <button type="button"
    class="bg-white text-gray-600 dark:bg-gray-600 dark:text-white w-9 h-9 mx-0.5 rounded shadow-md"
    :class="active
      ? 'text-orange dark:text-orange'
      : 'hover:bg-gray-600 active:bg-gray-700 hover:text-white active:text-white ' +
        'dark:hover:bg-gray-500 dark:active:bg-gray-700'">
          <font-awesome-icon v-if="icon" :icon="icon" />
  </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
